import { render, staticRenderFns } from "./SelectChannel.vue?vue&type=template&id=05bacc8c&scoped=true&"
import script from "./SelectChannel.vue?vue&type=script&lang=js&"
export * from "./SelectChannel.vue?vue&type=script&lang=js&"
import style0 from "./SelectChannel.vue?vue&type=style&index=0&id=05bacc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bacc8c",
  null
  
)

export default component.exports